"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Logo_1 = __importDefault(require("../Logo/Logo"));
const Spacer_1 = __importDefault(require("../Spacer/Spacer"));
const AioPage_1 = require("./AioPage");
const MobileMenu = (props) => {
    const renderMobileOverlay = () => {
        const elements = props.elements;
        return (React.createElement("div", { className: "aio-mobile-menu-overlay" },
            props.sidebarItems && AioPage_1.renderMenuList(props.sidebarItems),
            React.createElement(Spacer_1.default, { size: "sm" }),
            elements && elements
                .filter((el) => el.hideOnMobile !== true)
                .map((el) => el.element)));
    };
    if (!props.elements && !props.sidebarItems) {
        return (React.createElement("div", { className: "aio-mobile-menu" },
            React.createElement(Logo_1.default, null),
            React.createElement("div", null)));
    }
    const menuClassnames = classnames_1.default({
        'aio-mobile-menu': true,
        'aio-mobile-menu-open': props.open,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: menuClassnames },
            !props.open && React.createElement(Logo_1.default, null),
            React.createElement("button", { onClick: props.toggleOpen, className: "toggle-menu-button-container", type: "button" },
                React.createElement("div", { className: "toggle-menu-button-content", "aria-hidden": true }))),
        props.open && renderMobileOverlay()));
};
exports.default = MobileMenu;
//# sourceMappingURL=MobileMenu.js.map